module.exports = __webpack_public_path__ + "img/blue_045.006a186c.png";